import React from "react";

const EditIcon = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={color}
    >
      <path
        d="M16.0007 18.6669H1.33339V4.00122H10.1471L11.4805 2.66797H1.33339C0.979754 2.66797 0.640601 2.80844 0.390541 3.05847C0.140482 3.3085 0 3.64762 0 4.00122V18.6669C0 19.0205 0.140482 19.3596 0.390541 19.6097C0.640601 19.8597 0.979754 20.0002 1.33339 20.0002H16.0007C16.3543 20.0002 16.6935 19.8597 16.9436 19.6097C17.1936 19.3596 17.3341 19.0205 17.3341 18.6669V8.66758L16.0007 10.0008V18.6669Z"
        fill="#0073C8"
      />
      <path
        d="M19.6846 2.56191L17.4378 0.315392C17.3381 0.215418 17.2196 0.136099 17.0892 0.0819787C16.9588 0.0278582 16.819 0 16.6778 0C16.5365 0 16.3967 0.0278582 16.2663 0.0819787C16.1359 0.136099 16.0174 0.215418 15.9177 0.315392L6.77732 9.50813L6.03729 12.7146C6.00576 12.87 6.00907 13.0305 6.04699 13.1845C6.08491 13.3385 6.15649 13.4822 6.25658 13.6052C6.35667 13.7282 6.48279 13.8275 6.62586 13.896C6.76892 13.9645 6.92539 14.0004 7.084 14.0012C7.16598 14.0102 7.2487 14.0102 7.33068 14.0012L10.5642 13.2879L19.6846 4.08181C19.7845 3.98211 19.8639 3.86367 19.918 3.73326C19.9721 3.60286 20 3.46305 20 3.32186C20 3.18067 19.9721 3.04087 19.918 2.91046C19.8639 2.78006 19.7845 2.66161 19.6846 2.56191ZM9.87079 12.0546L7.43068 12.5946L7.99737 10.1748L14.8777 3.24853L16.7578 5.12841L9.87079 12.0546ZM17.5111 4.37513L15.631 2.49525L16.6644 1.44198L18.5578 3.3352L17.5111 4.37513Z"
        fill="#0073C8"
      />
    </svg>
  );
};

export default EditIcon;
